import { render, staticRenderFns } from "./AlertThresholdModal.vue?vue&type=template&id=ee87a052"
import script from "./AlertThresholdModal.vue?vue&type=script&lang=js"
export * from "./AlertThresholdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports